import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaAnalytics from './media-analytics-model'
import {
  CreateMediaAnalyticsAsync,
  DeleteMediaAnalyticsAsync,
  LoadMediaAnalyticssAsync,
} from './mediaAnalytics-thunk'
const initialState: mediaAnalyticsSliceState = {
  mediaAnalytics: [],
  selected_mediaAnalytics: '',
  is_loading_mediaAnalytics: false,
  is_creating_mediaAnalytics: false,
  is_deleting_mediaAnalytics: false,
}
export interface mediaAnalyticsSliceState {
  mediaAnalytics: MediaAnalytics[]
  selected_mediaAnalytics?: string
  is_loading_mediaAnalytics: boolean
  is_creating_mediaAnalytics: boolean
  is_deleting_mediaAnalytics: boolean
}
export const mediaAnalyticsSlice = createSlice({
  name: 'mediaAnalytics',
  initialState,
  reducers: {
    setSelectedmediaAnalytics: (state, action) => {
      state.selected_mediaAnalytics = action.payload
    },
    clearStatemediaAnalytics: (state) => {
      state.mediaAnalytics = []
      state.is_loading_mediaAnalytics = false
      state.is_creating_mediaAnalytics = false
      state.is_deleting_mediaAnalytics = false
    },
    mergemediaAnalytics: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaAnalytics = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaAnalytics = merge(state.mediaAnalytics, payload) as any
        }
      }
    },

    add_mediaAnalytics: (state, action) => {
      if (action.payload) {
        state.mediaAnalytics = [...state.mediaAnalytics, action.payload]
      }
    },
    set_mediaAnalytics: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaAnalytics = state.mediaAnalytics.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaAnalyticssAsync.pending, (state) => {
      state.is_loading_mediaAnalytics = true
    })
    builder.addCase(LoadMediaAnalyticssAsync.fulfilled, (state, action) => {
      state.is_loading_mediaAnalytics = false
      if (action.payload) {
        state.mediaAnalytics = action.payload
      }
    })
    builder.addCase(LoadMediaAnalyticssAsync.rejected, (state) => {
      state.is_loading_mediaAnalytics = false
    })
    builder.addCase(CreateMediaAnalyticsAsync.pending, (state) => {
      state.is_creating_mediaAnalytics = true
    })
    builder.addCase(CreateMediaAnalyticsAsync.fulfilled, (state) => {
      state.is_creating_mediaAnalytics = false
    })
    builder.addCase(CreateMediaAnalyticsAsync.rejected, (state) => {
      state.is_creating_mediaAnalytics = false
    })
    builder.addCase(DeleteMediaAnalyticsAsync.pending, (state) => {
      state.is_deleting_mediaAnalytics = true
    })
    builder.addCase(DeleteMediaAnalyticsAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaAnalytics = false
      if (state.mediaAnalytics) {
        state.mediaAnalytics = state.mediaAnalytics.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaAnalyticsAsync.rejected, (state) => {
      state.is_deleting_mediaAnalytics = false
    })
  },
})

export const {
  clearStatemediaAnalytics,
  setSelectedmediaAnalytics,
  set_mediaAnalytics,
  mergemediaAnalytics,
  add_mediaAnalytics,
} = mediaAnalyticsSlice.actions

export const get_mediaAnalytics =
  (id?: string) =>
  (state: {
    mediaAnalytics: {
      mediaAnalytics: MediaAnalytics[]
    }
  }): MediaAnalytics | null => {
    let temp = state?.mediaAnalytics?.mediaAnalytics?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaAnalytics?.mediaAnalytics[0] || null
  }
export const get_selected_mediaAnalytics = (state: {
  mediaAnalytics: mediaAnalyticsSliceState
}): MediaAnalytics | null => {
  let id = state?.mediaAnalytics?.selected_mediaAnalytics
  let temp = state?.mediaAnalytics?.mediaAnalytics?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaAnalytics = (state: {
  mediaAnalytics: {
    mediaAnalytics: MediaAnalytics[]
  }
}): MediaAnalytics[] => {
  let temp = state?.mediaAnalytics?.mediaAnalytics
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaAnalytics_busy = (state: {
  mediaAnalytics: mediaAnalyticsSliceState
}) => {
  return (
    state?.mediaAnalytics.is_deleting_mediaAnalytics ||
    state?.mediaAnalytics.is_loading_mediaAnalytics ||
    state?.mediaAnalytics.is_creating_mediaAnalytics
  )
}
export const is_deleting_mediaAnalytics_busy = (state: {
  mediaAnalytics: mediaAnalyticsSliceState
}) => {
  return state?.mediaAnalytics.is_deleting_mediaAnalytics
}
export const is_loading_mediaAnalytics_busy = (state: {
  mediaAnalytics: mediaAnalyticsSliceState
}) => {
  return state?.mediaAnalytics.is_loading_mediaAnalytics
}
export const is_creating_mediaAnalytics_busy = (state: {
  mediaAnalytics: mediaAnalyticsSliceState
}) => {
  return state?.mediaAnalytics.is_creating_mediaAnalytics
}

export default mediaAnalyticsSlice.reducer
